import { safeInternalPath } from '~/utils/safeInternalPath'
const LAST_INTERNAL_PATH_KEY = 'last_path'

/**
 * Persists an internal path in a short-lived cookie (10 min) so it can be restored
 * after authentication redirects. Ignores paths that don't start with `'/'`.
 * @param path - Absolute internal path (e.g. `'/results?lottery_id=1'`).
 */
export const saveLastInternalPath = (path: string) => {
	if (!path.startsWith('/')) return

	const cookie = useCookie(LAST_INTERNAL_PATH_KEY, {
		maxAge: 60 * 10, // 10 minutos es suficiente
		path: '/',
		sameSite: 'lax',
	})
	cookie.value = path
}

/**
 * Reads the last saved internal path from the cookie.
 * Returns `null` if absent or if the value is not a valid internal path.
 */
export const getLastInternalPath = () => {
	const cookie = useCookie<string | null>(LAST_INTERNAL_PATH_KEY)
	const value = cookie.value
	return safeInternalPath(value)
}

/** Clears the last-internal-path cookie (call after a successful post-login redirect). */
export const clearLastInternalPath = () => {
	const cookie = useCookie(LAST_INTERNAL_PATH_KEY, { path: '/' })
	cookie.value = null
}
